import api from './api';
import type {
  AINoteAnalyzeRequest,
  AINoteSuggestion,
  UserAIConfig,
  UserAIConfigRequest,
} from '@/types/ai.types';

export const aiApi = {
  // 分析笔记内容，返回 AI 建议
  analyzeNote: (payload: AINoteAnalyzeRequest) =>
    api.post('/ai/notes/analyze/', payload) as Promise<{
      data: { success: boolean; data: AINoteSuggestion; message: string };
    }>,

  // 获取用户 AI 配置
  getUserAIConfig: () =>
    api.get('/ai/config/') as Promise<{
      data: { success: boolean; data: UserAIConfig };
    }>,

  // 更新用户 AI 配置
  updateUserAIConfig: (payload: UserAIConfigRequest) =>
    api.put('/ai/config/', payload) as Promise<{
      data: { success: boolean; data: UserAIConfig; message: string };
    }>,
};
